import { render, staticRenderFns } from "./DocumentationIconView.vue?vue&type=template&id=bc860c1a&scoped=true&"
import script from "./DocumentationIconView.vue?vue&type=script&lang=js&"
export * from "./DocumentationIconView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc860c1a",
  null
  
)

export default component.exports